import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useMonitorButtonsStyles = createStyles(({ token }) => ({
  deleteButton: {
    position: 'absolute',
    top: -ThemeSpaces.SPACE_XS,
    right: -ThemeSpaces.SPACE_XS,
    color: token.colorPrimary,
    padding: `0 0 ${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_SM}px`,
  },
}));
